import { Outlet } from 'react-router-dom'

const Profiling = () => <Outlet />

export default Profiling
